export var SnippetSymbolEnum;
(function (SnippetSymbolEnum) {
    SnippetSymbolEnum["POST_PROCESS"] = "#";
    SnippetSymbolEnum["VALUE_MODIFIER"] = "@";
    SnippetSymbolEnum["PARAMETER"] = ":";
    SnippetSymbolEnum["LIST_OPTION"] = ",";
})(SnippetSymbolEnum || (SnippetSymbolEnum = {}));
export var SnippetMathOperatorEnum;
(function (SnippetMathOperatorEnum) {
    SnippetMathOperatorEnum["ADDITION"] = "+";
    SnippetMathOperatorEnum["SUBTRACTION"] = "-";
    SnippetMathOperatorEnum["DIVISION"] = "/";
    SnippetMathOperatorEnum["MULTIPLICATION"] = "*";
})(SnippetMathOperatorEnum || (SnippetMathOperatorEnum = {}));
export var SnippetTagValueTypeEnum;
(function (SnippetTagValueTypeEnum) {
    SnippetTagValueTypeEnum["SPEED"] = "speed";
    SnippetTagValueTypeEnum["SAVE_DC"] = "savedc";
    SnippetTagValueTypeEnum["SPELL_ATTACK"] = "spellattack";
    SnippetTagValueTypeEnum["SCALE_VALUE"] = "scalevalue";
    SnippetTagValueTypeEnum["MODIFIER"] = "modifier";
    SnippetTagValueTypeEnum["ABILITY_SCORE"] = "abilityscore";
    SnippetTagValueTypeEnum["FIXED_VALUE"] = "fixedvalue";
    SnippetTagValueTypeEnum["CLASS_LEVEL"] = "classlevel";
    SnippetTagValueTypeEnum["CHARACTER_LEVEL"] = "characterlevel";
    SnippetTagValueTypeEnum["PROFICIENCY"] = "proficiency";
    SnippetTagValueTypeEnum["MAX_HP"] = "maxhp";
    SnippetTagValueTypeEnum["LIMITED_USE"] = "limiteduse";
})(SnippetTagValueTypeEnum || (SnippetTagValueTypeEnum = {}));
export var SnippetValueModifierTypeEnum;
(function (SnippetValueModifierTypeEnum) {
    SnippetValueModifierTypeEnum["MIN"] = "min";
    SnippetValueModifierTypeEnum["MAX"] = "max";
    SnippetValueModifierTypeEnum["ROUND_DOWN"] = "rounddown";
    SnippetValueModifierTypeEnum["ROUND_UP"] = "roundup";
})(SnippetValueModifierTypeEnum || (SnippetValueModifierTypeEnum = {}));
export var SnippetPostProcessTypeEnum;
(function (SnippetPostProcessTypeEnum) {
    SnippetPostProcessTypeEnum["SIGNED_NUMBER"] = "signed";
    SnippetPostProcessTypeEnum["UNSIGNED_NUMBER"] = "unsigned";
    SnippetPostProcessTypeEnum["MIN"] = "min";
    SnippetPostProcessTypeEnum["MAX"] = "max";
    SnippetPostProcessTypeEnum["ROUND_UP"] = "roundup";
    SnippetPostProcessTypeEnum["ROUND_DOWN"] = "rounddown";
})(SnippetPostProcessTypeEnum || (SnippetPostProcessTypeEnum = {}));
export var SnippetAbilityKeyEnum;
(function (SnippetAbilityKeyEnum) {
    SnippetAbilityKeyEnum["STRENGTH"] = "str";
    SnippetAbilityKeyEnum["DEXTERITY"] = "dex";
    SnippetAbilityKeyEnum["CONSTITUTION"] = "con";
    SnippetAbilityKeyEnum["INTELLIGENCE"] = "int";
    SnippetAbilityKeyEnum["WISDOM"] = "wis";
    SnippetAbilityKeyEnum["CHARISMA"] = "cha";
})(SnippetAbilityKeyEnum || (SnippetAbilityKeyEnum = {}));
export var SnippetSpeedMovementKeyEnum;
(function (SnippetSpeedMovementKeyEnum) {
    SnippetSpeedMovementKeyEnum["WALK"] = "walk";
    SnippetSpeedMovementKeyEnum["FLY"] = "fly";
    SnippetSpeedMovementKeyEnum["BURROW"] = "burrow";
    SnippetSpeedMovementKeyEnum["SWIM"] = "swim";
    SnippetSpeedMovementKeyEnum["CLIMB"] = "climb";
})(SnippetSpeedMovementKeyEnum || (SnippetSpeedMovementKeyEnum = {}));
export var SnippetContentChunkTypeEnum;
(function (SnippetContentChunkTypeEnum) {
    SnippetContentChunkTypeEnum["TEXT"] = "TEXT";
    SnippetContentChunkTypeEnum["TAG"] = "TAG";
})(SnippetContentChunkTypeEnum || (SnippetContentChunkTypeEnum = {}));
export var SnippetTagDataTypeEnum;
(function (SnippetTagDataTypeEnum) {
    SnippetTagDataTypeEnum["STRING"] = "STRING";
    SnippetTagDataTypeEnum["NUMBER"] = "NUMBER";
    SnippetTagDataTypeEnum["ERROR"] = "ERROR";
})(SnippetTagDataTypeEnum || (SnippetTagDataTypeEnum = {}));
